import { Component, OnInit } from '@angular/core';
import { UserSessionService } from '../../UserSession/user-session.service';
import { SystemService } from '../../apiclient';
import { ExcelExporterService } from '../../excel-exporter.service';
import {Location} from '@angular/common';
import { NbToastrService } from '@nebular/theme';


/**
 * Componente que renderiza el Importador de entidades
 */
@Component({
  selector: 'ngx-entitiesimporter',
  templateUrl: './entitiesimporter.component.html',
  styleUrls: ['./entitiesimporter.component.scss']
})
export class EntitiesimporterComponent implements OnInit {

  loading: boolean = false;
  companies: any;
  selectedCompany: any;
  entitiesToUpload: any;

  settings = {};  //Esther EV2022-02
  
  constructor(private userSessionService: UserSessionService,
    private systemService: SystemService,
    private exporterExcelService: ExcelExporterService,
    private toastrService: NbToastrService,
    private location: Location) { }

    /**
     * @ignore
     */
  ngOnInit(): void {
    this.settings = {
      text: "Compañias",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      labelKey:"name",
      singleSelection: true,
      enableSearchFilter: true,
    };  //Esther EV2022-02 

    this.userSessionService.getCompanies().subscribe((companies) => {
      this.companies = companies;
    })


  }

/**
 * Regresa a la página anterior
 */
  back(): void{
    this.location.back()
  }

  /**
   * Importa un conjunto de entidades desde un archivo excel
   */
  importarExcel(): void{

    if(this.selectedCompany != null && this.entitiesToUpload != null){
      this.loading = true;
        console.log(this.entitiesToUpload)
        this.systemService.uploadEntities(+this.selectedCompany,this.entitiesToUpload,this.userSessionService.accessToken).subscribe((resultado) => {
            this.loading = false;
            this.toastrService.success("Se ha iniciado el proceso de actualización de entidades");
            this.back();
        })
    }else{
            this.toastrService.warning("Debe seleccionar una compañía");
    }
  }

  /**
   * Genera un archivo excel con las entidades de la compañía
   */
  generarExcel(): void{

    if(this.selectedCompany != null){
      this.loading = true;
      this.systemService.listEntities(+this.selectedCompany,this.userSessionService.accessToken).subscribe((resultado) => {
        console.log(resultado);
        this.exporterExcelService.exportEntities(resultado);
        console.log("lo hemos intentado")
        this.loading = false;
      })
    }else{
      this.exporterExcelService.exportEntities({machinerylist:[],diseaselist:[],maintenancelist:[],productlist:[]});
    }

  }

  /**
   * @ignore
   * @param archivos
   */
  actualizarArchivo(archivos: FileList){

    console.log(archivos);
    this.loading = true;
    this.exporterExcelService.readExcelEntities(archivos.item(0)).then((resultado)=>{
      this.entitiesToUpload = resultado;
      this.loading = false;
    })



  }
}
